(() => {
  if (window.AVNTCompleteTheFit) return;
  window.AVNTCompleteTheFit = true;

  const cartCount = document.querySelector('.site-header__cart-count');

  function updateStatus(card, message) {
    const status = card?.querySelector('[data-avnt-complete-fit-status]');
    if (status) status.textContent = message;
  }

  function setButtonState(button, state) {
    button.classList.toggle('is-loading', state === 'loading');
    button.classList.toggle('is-added', state === 'added');

    if (state === 'loading') {
      button.setAttribute('aria-disabled', 'true');
    } else if (!button.disabled) {
      button.removeAttribute('aria-disabled');
    }
  }

  function syncCartCount() {
    if (!cartCount) return Promise.resolve();

    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (!cart) return;
        cartCount.textContent = cart.item_count;
      });
  }

  function addVariant(button) {
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    const card = button.closest('[data-avnt-complete-fit-card]');
    const variantId = button.dataset.avntCompleteFitVariantId;
    const productTitle = button.dataset.avntCompleteFitProductTitle || 'Item';
    const variantTitle = button.dataset.avntCompleteFitVariantTitle || '';

    if (!variantId) return;

    setButtonState(button, 'loading');
    updateStatus(card, `Adding ${variantTitle || 'size'}...`);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('Unable to add this item right now.')))
      .then(() => syncCartCount())
      .then(() => {
        setButtonState(button, 'added');
        updateStatus(card, `${productTitle}${variantTitle ? ` ${variantTitle}` : ''} added to bag.`);
        window.setTimeout(() => {
          button.classList.remove('is-added');
        }, 1600);
      })
      .catch((error) => {
        console.error(error);
        updateStatus(card, error.message || 'Unable to add this item right now.');
      })
      .finally(() => {
        setButtonState(button, button.classList.contains('is-added') ? 'added' : 'idle');
      });
  }

  document.addEventListener('click', (event) => {
    const scrollTrigger = event.target.closest('[data-avnt-complete-fit-scroll]');
    if (scrollTrigger) {
      event.preventDefault();
      const target = document.getElementById(scrollTrigger.dataset.avntCompleteFitScroll);
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const sizeButton = event.target.closest('[data-avnt-complete-fit-variant-id]');
    if (sizeButton) {
      event.preventDefault();
      addVariant(sizeButton);
    }
  });
})();
